export enum CandleType {
	FILL_PRICE = 'FILL_PRICE',
	ORACLE_PRICE = 'ORACLE_PRICE',
}
